var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[(_vm.hasProductsInBasket)?_c('div',{staticClass:"cart",on:{"click":_vm.expandCart}},[(!_vm.isWishlistMode)?_c('IconBasket',{staticClass:"cart__icon"}):_c('IconWishlist',{staticClass:"cart__icon"}),_vm._v(" "),_c('span',{staticClass:"cart__label"},[_vm._v(_vm._s(_vm._f("formatPrice")(_vm.totalPrice)))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }